'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';
import { Modal } from '@/lib/Modal';
import { RecordingHistory } from '@/lib/RecordingHistory';

function JoinMeetingTab() {
  const router = useRouter();
  const [roomId, setRoomId] = useState('');
  const [passphrase, setPassphrase] = useState('');

  const joinMeeting = () => {
    if (passphrase) {
      router.push(`/rooms/${roomId}#${encodePassphrase(passphrase)}`);
    } else {
      router.push(`/rooms/${roomId}`);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-white my-10">Partecipa a una riunione</h2>

      <div className={styles.tabContent}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <label htmlFor="room-id" className="text-sm text-gray-300">ID riunione</label>
          <input
            id="room-id"
            type="text"
            value={roomId}
            onChange={(ev) => setRoomId(ev.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <label htmlFor="passphrase" className="text-sm text-gray-300">Password (se prevista)</label>
          <input
            id="passphrase"
            type="text"
            value={passphrase}
            onChange={(ev) => setPassphrase(ev.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            disabled={roomId.trim() === ''}
            className="lk-button bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={joinMeeting}
          >
            Entra nella riunione
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Page() {
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  return (
    <main className="flex flex-col justify-center items-center min-h-screen p-6 w-full max-w-[720px] mx-auto" data-lk-theme="default">

      <JoinMeetingTab />
      
      <div className="mt-8">
        <button
          className="text-sm text-blue-400 hover:underline"
          onClick={() => setIsHistoryOpen(true)}
        >
          Gestisci Registrazioni Locali
        </button>
      </div>

      <Modal
        isOpen={isHistoryOpen}
        onClose={() => setIsHistoryOpen(false)}
        title="Cronologia Registrazioni Locali"
      >
        {/* Qui viene chiamato senza `currentRoomId`, quindi mostrerà tutte le registrazioni. */}
        <RecordingHistory />
      </Modal>

    </main>
  );
}
